import type { OpenTime } from '@/pages/Place/place.data';
import { DayOfWeek } from '@/pages/Place/place.enum';
import type {
  BlockItinerary,
  BlockPlace,
  BlockPlaceDetail,
  TripDataType,
} from '@/pages/Trip/trip.data';
import _ from 'lodash';
import type { Moment } from 'moment';
import moment from 'moment';

export function convertNumberToTime(num: number) {
  const quotient = Math.floor(num / 100);
  const remainder = num % 100;

  const seconds = quotient * 3600 + remainder * 60;

  return moment.utc(seconds * 1000);
}

export function convertTimeToNumber(time: Moment) {
  return parseInt((<Moment>time).format('HHmm'), 10);
}

export function normalizeOpenTime(openTime: OpenTime[] | undefined) {
  if (!openTime) {
    return [];
  }

  const openTimeConverted = openTime.map((value) => {
    return {
      day: <DayOfWeek | unknown>value.day,
      startTime:
        typeof value.startTime === 'number'
          ? convertNumberToTime(<number>value.startTime)
          : undefined,
      endTime:
        typeof value.endTime === 'number' ? convertNumberToTime(<number>value.endTime) : undefined,
      dayOff: <boolean>value.dayOff,
    };
  });

  return Object.keys(DayOfWeek).map((value: string) => {
    const foundOpenTime = openTimeConverted.find((time) => time.day === value);
    if (!foundOpenTime) {
      return {
        day: value,
        startTime: null,
        endTime: null,
      };
    }

    return foundOpenTime;
  });
}

export function normalizeOpenTimeBeforeSend(openTime: OpenTime[]): any[] {
  return openTime.map((time) => {
    return {
      ...time,
      startTime: time.startTime ? convertTimeToNumber(<Moment>time.startTime) : null,
      endTime: time.endTime ? convertTimeToNumber(<Moment>time.endTime) : null,
      dayOff: time.dayOff ?? false,
    };
  });
}

export function normalizeTotalPlaceInTrip(trip: TripDataType) {
  let places: any[] = [];
  if (!_.isEmpty(trip.blockItineraries)) {
    trip.blockItineraries.forEach((block: BlockItinerary) => {
      places = [...places, ..._.map(block.places, (blockPlace) => blockPlace.place)];
    });
  }

  if (!_.isEmpty(trip.blockPlaces)) {
    trip.blockPlaces.forEach((block: BlockPlace) => {
      places = [
        ...places,
        ..._.map(block.places, (blockPlace: BlockPlaceDetail) => blockPlace.place),
      ];
    });
  }

  return _.uniq(places).length;
}
